import { css, type Theme } from '@emotion/react';

export const moodTrackerCard = css`
  position: relative;

  width: 100%;
  border-radius: 8px;
`;

export const header = css`
  display: flex;
  flex-direction: column;
  gap: 16px;

  align-items: center;
`;

export const moodTrackerCardBody = css`
  display: flex;
  flex-direction: column;
  gap: 20px;

  align-items: center;
`;

export const moodBoxes = css`
  display: flex;
  gap: 20px;
`;

export const textarea = css`
  resize: none;
  margin-top: 10px;
`;

export const cardActions = css`
  display: flex;
  justify-content: space-between;
  gap: 10px;

  margin-top: 10px;
`;

export const cardAction = css`
  width: 100%;
`;

export const title = css`
  text-align: center;
`;

export const closeButton = css`
  position: absolute;
  top: 0px;
  right: 0px;
`;

export const appointmentLink = (theme: Theme) => css`
  color: ${theme.colors.primary[500]};

  margin-left: 4px;
`;

export const subtitle = css`
  text-align: center;
`;
